import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import { Switch } from '@/components/ui/switch'

import * as S from './block-item.styled'
import { BlockItemLabel } from './block-item-label'

interface StaticBlockItemProps {
  label: string
  checked: boolean
  disabled?: boolean
  onToggle: () => void
}

// Same row shape as SortableBlockItem but not draggable - used only for buildingImage, which is
// locked to the first position.
export const StaticBlockItem = ({ label, checked, disabled, onToggle }: StaticBlockItemProps) => (
  <S.Row>
    <S.DragHandle $disabled>
      <Icon icon={DotsSixVerticalIcon} size="1.6rem" />
    </S.DragHandle>
    <S.Label>
      <BlockItemLabel label={label} />
    </S.Label>
    <Switch checked={checked} disabled={disabled} size="small" onChange={onToggle} />
  </S.Row>
)
